import {Component, input, computed} from '@angular/core';
import {EmployeeCapacity} from '../../../../classes/models/employee/EmployeeCapacity';
import moment from 'moment';
import {SHARED_IMPORTS} from "../../../../shared/standalone-imports";

/**
 * This component displays an employee capacity data for an hour of a day, on daily rota page.
 */
@Component({
  selector: 'app-rota-day-employee-capacity',
  templateUrl: './rota-day-employee-capacity.component.html',
  styleUrls: ['./rota-day-employee-capacity.component.less'],
  imports: [SHARED_IMPORTS]
})
export class RotaDayEmployeeCapacityComponent {

  /** An hour in a daily rota. */
  hour = input<string>();
  /** An employee capacity data for each hour in a day. */
  employeeCapacityList = input<EmployeeCapacity[]>([]);

  /** Employee capacity data for the selected hour. */
  employeeCapacity = computed(() =>
          this.employeeCapacityList().find(list => list.hour === this.hour())
  );

  /** The number of maximum footfall prediction in a day. */
  maxFootfall = computed(() =>
          this.employeeCapacityList()
                  .map(list => list.footfall)
                  .reduce((prev, curr) => curr > prev ? curr : prev, 0)
  );

  /** The start of the selected hour. */
  startHour = computed(() =>
          moment(this.hour(), 'HH:mm:ss').format('HH:mm')
  );

  /** The end of the selected hour. */
  endHour = computed(() =>
          moment(this.hour(), 'HH:mm:ss').add(1, 'hour').format('HH:mm')
  );

  /**
   * Rounds up the given number.
   * @param number a number to round up.
   */
  roundUp(number: number): number {
    return Math.ceil(number);
  }
}